<div class="mask d-flex align-items-center h-100" style="background-color: rgba(255,255,255,.6);">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-md-8 col-lg-6 col-xl-5">
                <div class="card gradient-custom" style="border-radius: 1rem;">
                    <div class="card-body p-5 text-white">

                        <form [formGroup]="form">
                            <div *ngIf="mercati.length" class="row my-n4">
                            <div class="md-form col">
                                <mdb-select style="min-width:80px" placeholder="Mercato" id="form" class="form-control" formControlName="mkt">
                                    <mdb-option *ngFor="let row of mercati.sort()" [value]="row">{{ row }}</mdb-option>
                                  </mdb-select>
                            </div>
                            <div class="md-form col">
                                <mdb-select style="min-width:80px" placeholder="Verso operazione" id="form" class="form-control" formControlName="verso">
                                    <mdb-option *ngFor="let row of versoOperazione" [value]="row">{{ row }}</mdb-option>
                                  </mdb-select>
                            </div>
                            </div>
                            <div  formControlName="stoploss" class="md-form">
                                <input type="text" id="sl" class="form-control"
                                    mdbInput />
                                <label for="sl">Stop Loss</label>
                            </div>
                            <div class="md-form">
                                <input type="text" id="nbarre" class="form-control"
                                    formControlName="numerobarre" mdbInput />
                                <label for="nbarre">Numero Barre</label>
                            </div>
                            <div class="md-form">
                                <input type="text" id="serie" class="form-control"
                                    formControlName="seriebarre" mdbInput />
                                <label for="serie">Serie di Barre</label>
                            </div>
                            <div class="md-form">
                                <input type="text" id="min" class="form-control"
                                    formControlName="barraminima" mdbInput />
                                <label for="min">Barra Minima</label>
                            </div>
                            <div class="row my-n4">
                            <div class="md-form col">
                                <mdb-checkbox (change)="check()" formControlName="chkTP">Set Take Profit: </mdb-checkbox>
                            </div>
                            <div class="md-form col">
                                <input type="text" id="tp" class="form-control"
                                    formControlName="tp" mdbInput />
                                <label for="tp">Take Profit</label>
                            </div>
                            </div>
                            
                            <div class="md-form">
                                <mdb-select style="min-width:80px" placeholder="PASK" id="pask" class="form-control" formControlName="pask">
                                    <mdb-option *ngFor="let row of arrayPask" [value]="row">{{ row }}</mdb-option>
                                  </mdb-select>
                            </div>
                        </form>
                        <div class="text-center mb-3">
                            <button type="button" mdbBtn gradient="blue" block="true" rounded="true"
                                class="z-depth-1a waves-light" (click)="calcola()" mdbWavesEffect>
                                Calcola
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="chartOptions"
    style="width: 100%; height: 400px; display: block;"></highcharts-chart>